<template>
  <div class="save-button-wrapper ml-1">
    <div
      :class="
        form.deliverySetting.menuSetting.simulationLocationsAllCount > 20000
          ? 'disabled-save-button'
          : 'save-button'
      "
    >
      <v-overflow-btn
        :items="items"
        :disabled="
          form.deliverySetting.menuSetting.simulationLocationsAllCount > 20000
        "
        v-model="selected"
        @change="onChange"
        :background-color="
          form.deliverySetting.menuSetting.simulationLocationsAllCount > 20000
            ? '#cccccc'
            : 'primary'
        "
        flat
        solo
        dense
        item-text="text"
        segmented
        hide-selected
      >
        <template v-slot:item="props">
          <div
            ref="btnItem"
            @click.stop="props.item.callback"
            class="dropdown-item caption d-flex justify-center align-center"
          >
            {{ props.item.text }}
          </div>
        </template>
      </v-overflow-btn>
      <SimulationSaveAsNameModal
        @close="closeSaveAsNameModal"
        @toggleIsRegistering="$emit('toggleIsRegistering')"
        v-model="isShowSaveAsNameModal"
        :form="form"
      />
    </div>
  </div>
</template>

<script>
import SimulationSaveAsNameModal from '@/components/Shared/Simulation/SimulationSaveAsNameModal'
import { mapActions } from 'vuex'
import { snackbarType } from '@/vuex/modules/ui/snackbar/constants'
export default {
  name: 'SimulationFooterEditButtonSave',
  components: {
    SimulationSaveAsNameModal,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isShowSaveAsNameModal: false,
      selected: '上書き保存',
      items: [
        { text: '上書き保存', callback: () => this.onUpdate() },
        {
          text: '名前を付けて保存',
          callback: () => this.openSaveAsNameModal(),
        },
      ],
    }
  },
  mounted() {
    const listItem = this.$refs.btnItem.parentNode.parentNode.parentNode
    listItem.style.backgroundColor = '#1976d2'
    listItem.style.width = '100%'
    listItem.style.height = '100%'
  },
  methods: {
    ...mapActions('snackbar', {
      showSnackbar: 'SHOW_SNACKBAR',
    }),
    async onUpdate() {
      const validationMessages = this.form.basicSetting.validation()
      if (validationMessages.length > 0) {
        const validationMessage = validationMessages.join('\n')
        this.$confirm(`シミュレーション登録エラー`, {
          onlyOk: true,
          okText: '閉じる',
          body: validationMessage,
        })
        return
      }
      try {
        this.$emit('toggleIsRegistering')
        await this.form.update()
        this.showSnackbar({
          type: snackbarType.SUCCESS,
          message: 'シミュレーションを更新しました',
        })
        this.$emit('toggleIsRegistering')
      } catch (e) {
        this.$emit('toggleIsRegistering')
        this.showSnackbar({
          type: snackbarType.ERROR,
          message: 'シミュレーションの更新に失敗しました',
        })
      }
    },
    closeSaveAsNameModal() {
      this.isShowSaveAsNameModal = false
    },
    openSaveAsNameModal() {
      this.isShowSaveAsNameModal = true
    },
    onChange() {
      this.$nextTick(() => {
        this.selected = '上書き保存'
      })
    },
  },
}
</script>
<style lang="scss">
$button-width: 130px;
$button-height: 36px;
$down-icon-width: 24px;
$caption: 14px;

.save-button-wrapper {
  display: inline-block;
}

.save-button {
  i {
    color: white !important;
  }
  button {
    width: 100%;
    height: 100%;
  }
  .v-messages {
    min-height: 0;
  }
  .v-select__slot {
    height: $button-height;
    margin: 0;
    padding: 0;
  }
  .v-input__append-inner {
    height: $button-height;
  }
  .v-input__icon {
    .primary--text {
      color: white;
    }
  }
  .v-select__slot {
    min-width: $button-width;
  }
  .v-input__append-inner {
    width: $down-icon-width;
  }
  .v-input__control::before {
    display: none;
  }
  .v-text-field--solo .v-input__control {
    min-height: $button-height;
  }
  .v-text-field.v-text-field--enclosed {
    .v-input__slot {
      padding: 0;
    }
    .v-text-field__details {
      margin-bottom: 0;
    }
  }
  .theme--light.v-icon {
    color: white;
  }
  .v-btn__content {
    font-size: $caption;
    color: white;
  }
  .v-overflow-btn--segmented {
    .v-input__append-inner {
      border-right: 1px solid rgba(0, 0, 0, 0.12);
    }
    .v-select__selections .v-btn {
      margin: 0;
      height: $button-height;
    }
  }
  .dropdown-item {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.disabled-save-button {
  i {
    color: white !important;
  }
  button {
    width: 100%;
    height: 100%;
  }
  .v-messages {
    min-height: 0;
  }
  .v-select__slot {
    height: $button-height;
    margin: 0;
    padding: 0;
  }
  .v-input__append-inner {
    height: $button-height;
  }
  .v-input__icon {
    .primary--text {
      color: white;
    }
  }
  .v-select__slot {
    min-width: $button-width;
  }
  .v-input__append-inner {
    width: $down-icon-width;
  }
  .v-input__control::before {
    display: none;
  }
  .v-text-field--solo .v-input__control {
    min-height: $button-height;
  }
  .v-text-field.v-text-field--enclosed {
    .v-input__slot {
      padding: 0;
    }
    .v-text-field__details {
      margin-bottom: 0;
    }
  }
  .theme--light.v-icon {
    color: white;
  }
  .v-btn__content {
    font-size: $caption;
    color: #999999;
  }
  .v-overflow-btn--segmented {
    .v-input__append-inner {
      border-right: 1px solid rgba(0, 0, 0, 0.12);
    }
    .v-select__selections .v-btn {
      margin: 0;
      height: $button-height;
    }
  }
  .dropdown-item {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
